import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from '@angular/material/card';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminService } from '../../core/services/admin/admin.service';

interface MigrationButton {
  label: string;
  code: string;
}

@Component({
  selector: 'app-migrations',
  standalone: true,
  imports: [MatButton, MatCard, MatCardHeader, MatCardTitle, MatCardContent],
  templateUrl: './migrations.component.html',
  styleUrls: ['./migrations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MigrationsComponent {
  private readonly adminService = inject(AdminService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly destroyRef = inject(DestroyRef);

  public readonly migrations: MigrationButton[] = [
    { label: 'Main', code: 'main' },
    { label: 'Notification', code: 'notification' },
    { label: 'Internal Notification', code: 'internal-notification' },
    { label: 'Kernel Integration', code: 'kernel-integration' },
  ];

  /** `null` until the first run — an empty list means the run found nothing pending. */
  public readonly executedMigrations = signal<string[] | null>(null);

  public runMigration(code: string): void {
    this.adminService
      .runMigration(code)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (migrations) => {
          this.executedMigrations.set(migrations);
          this.snackBar.open(`Міграцію "${code}" запущено.`, 'OK', { duration: 3000 });
        },
        error: () => {
          this.snackBar.open(`Не вдалося запустити міграцію "${code}".`, 'OK', { duration: 4000 });
        },
      });
  }
}
